const TOTAL_MINUTES = 1440
const OFFSET_MINUTES = 0
const ONE_HOUR_IN_MINUTES = 60

export default {
    methods: {
        _getDateWithoutTimezone(date) {
            const dateWithoutTimezone = date.split('+')[0] // 2021-04-02T09:00:00+0200
            return new Date(dateWithoutTimezone)
        },
        _getOffsetPercent(offset, total_min) {
            return `${(offset / total_min) * 100}%`
        },
        _getMinutesOffsetFromDate(date, offset_minutes) {
            return (
                date.getHours() * ONE_HOUR_IN_MINUTES
        + date.getMinutes()
        - offset_minutes
            )
        },
        _getHoursOffset(date, total_min = null, offset_minutes = null) {
            const localTotalMin = total_min || TOTAL_MINUTES
            const localOffset = offset_minutes || OFFSET_MINUTES

            const newDate = this._getDateWithoutTimezone(date)
            const offset = this._getMinutesOffsetFromDate(newDate, localOffset)

            return Math.sign(offset) === -1
                ? '0%'
                : this._getOffsetPercent(offset, localTotalMin)
        },

        _getHoursOffset2(date, total_min = null) {
            const localTotalMin = total_min || TOTAL_MINUTES

            const newDate = this._getDateWithoutTimezone(date)
            const offset = this._getMinutesOffsetFromDate(newDate, 0)

            return Math.sign(offset) === -1
                ? '0%'
                : this._getOffsetPercent(offset, localTotalMin)
        },

        // to redactor
        _getWidthBlock(date_from, predicted_time, total_min = null) {
            const localTotalMin = total_min || TOTAL_MINUTES
            const localPredictedTime = predicted_time.toString()

            const splittedTime = localPredictedTime.split(':')
            if (splittedTime[1] === undefined) {
                const final = (((localPredictedTime / 60) * ONE_HOUR_IN_MINUTES) / localTotalMin) * 100
          - 0.3
                return final === '0%' ? '8.1%' : `${final}%`
            } else {
                const final = parseFloat(splittedTime[0]) * ONE_HOUR_IN_MINUTES
          + parseFloat(splittedTime[1])
                return `${(final / localTotalMin) * 100 - 0.3}%`
            }
        },

        _getWidthBlockWeek(date_from, predicted_time, total_min = null) {
            const localTotalMin = total_min || TOTAL_MINUTES

            if (predicted_time >= 480) return '37.5%'

            const final = (((predicted_time / 60) * ONE_HOUR_IN_MINUTES) / localTotalMin) * 100 - 0.3
            return `${final}%`
        },
    },
}
